<template>
  <div>
    <FilterCommon :model="model" :isAdd="false" @search="search" :isReset="true" @reset="reset" :isTime="true" @time="time">
      <template v-slot:button>
        <!-- 新增超时配置和更新超时配置状态的按钮 按钮权限显示字段同批量质检 -->
        <el-button type="primary" @click="overTimeSet" v-if="batchShow">超时配置</el-button>
        <el-button type="primary" @click="updateOverTime" v-if="batchShow">更新超时状态</el-button>
        <el-button type="primary" @click="operateOverTime" v-if="batchShow">修复超时状态</el-button>
        <!-- 新增去除超时按钮 -->
        <el-button type="primary" @click="clearOverTime" v-if="batchShow">去除超时状态</el-button>
        <!-- 新增转移按钮 -->
        <el-button type="primary" @click="operateTransfer" v-if="transferBtn">转移</el-button>
      </template>
    </FilterCommon>
    <el-table border v-loading="listLoading" :data="tableData" style="width: 100%" min-height="200" max-height="1000" @selection-change="handleSelectionChange">
      <!-- 选项框 -->
      <el-table-column type="selection" width="55"></el-table-column>
      <el-table-column prop="account" label="账号">
        <template slot-scope="scope">
          <!-- <el-link :type="scope.row.is_vip_checkout === 1 ? 'warning' : 'primary'" @click="chooseAcc(scope.row)">{{ scope.row.account }}</el-link> -->
          <el-link type="primary" v-if="scope.row.is_vip_checkout === 0" @click="chooseAcc(scope.row)">{{ scope.row.account }}</el-link>
          <el-link type="warning" v-if="scope.row.is_vip_checkout === 1" @click="chooseAcc(scope.row)">{{ scope.row.account }}</el-link>
          <el-link type="success" v-if="scope.row.is_vip_checkout === 2" @click="chooseAcc(scope.row)">{{ scope.row.account }}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="total_money" label="总充值" />
      <el-table-column prop="staff_name" label="接待客服" />
      <el-table-column prop="nickname" label="客服昵称" />
      <el-table-column prop="game_tag" label="游戏标签" />
      <el-table-column prop="chat_at" label="会话开始时间" />
      <el-table-column prop="first_request_at" label="首次来访时间" />
      <el-table-column prop="first_response_at" label="首次响应时间" />
      <el-table-column prop="channel_text" label="渠道" />
      <el-table-column prop="check_admin_name" label="质检人" />
      <el-table-column prop="is_tag" label="是否打标签" />
      <el-table-column prop="is_outdated" label="是否超时" />
      <el-table-column prop="check_result_text" label="质检结果" />
      <el-table-column prop="remark" label="备注" />
    </el-table>
    <pagination v-show="total > 0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit" @pagination="getList" />

    <Drawer ref="drawer" @refresh="refresh"></Drawer>
    <Dialog ref="dialog" @submitForm="dialogSure" @closeDialog="closeDialog" :dialogTitle="'设置超时时间'" :dialogVisible="dialogVisible" :dialogModel="dialogModel" dialogWidth="700px"></Dialog>

    <!-- 新增的修复超时状态的弹窗相关信息 -->
    <Dialog
      ref="dialog"
      @submitForm="overTimedialogSure"
      @closeDialog="closeDialog"
      :dialogTitle="'修复超时状态'"
      :dialogVisible="overTimedialogVisible"
      :dialogModel="overTimedialogModel"
      dialogWidth="700px"
    ></Dialog>
    <!-- 更新超时状态的二次确认弹框 -->
    <el-dialog title="更新超时状态" center width="40%" :visible.sync="updateOverTimeShow">
      <p style="text-align: center">确认更新超时状态？</p>
      <div slot="footer" class="dialog-footer">
        <el-button @click="updateCancel">取 消</el-button>
        <el-button type="primary" @click="updateSure">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Dialog from '@/components/common/Dialog';
import Drawer from '../component/Drawer';
import FilterCommon from '@/components/common/Filter';
import Pagination from '@/components/pagination/index';
import { getInspectionList, getConfigSetting, setConfigSetting, operateOverTimeSet, transferDataList, eraseInspectionTimeout } from '@/api/vipQualityTest';
import dayjs from 'dayjs';

export default {
  components: {
    FilterCommon,
    Pagination,
    Drawer,
    Dialog,
  },
  props: {
    options: {
      type: Object,
      default: function () {
        return {
          admin: [],
          channel: [],
          check: [],
          nickname: [],
          result: [],
          tag: [],
          time: [],
        };
      },
    },
  },
  data() {
    return {
      listLoading: false,
      tableData: [],
      total: 0,
      listQuery: {
        is_checked: 1,
        page: 1,
        limit: 10,
        start_time: dayjs(new Date() - 1000 * 60 * 60 * 24 * 7).format('YYYY-MM-DD'),
        end_time: dayjs(new Date()).format('YYYY-MM-DD')
      },
      setTime: '',
      batchShow: false, // 超时配置相关按钮的设置
      dialogVisible: false,
      dialogModel: [
        {
          type: 'el-input',
          label: '超时时间（秒）',
          prop: 'config_values',
        },
      ],
      // 修复超时状态相关的弹窗数据
      overTimedialogVisible: false,
      overTimedialogModel: [
        {
          type: 'el-date-picker',
          label: '选择日期：',
          prop: 'calc_date',
          format: 'yyyy-MM-dd',
          dateType: 'date',
        },
      ],
      // 更新超时状态的弹窗相关属性
      updateOverTimeShow: false,
      // 新增转移按钮的显示
      transferBtn: false,
      transferIdArray: [],
    };
  },
  computed: {
    model() {
      return [
        {
          type: 'input',
          label: '账号',
          key: 'account',
          span: 4,
        },
        {
          type: 'input',
          label: '接待客服',
          key: 'staff_name',
          span: 4,
        },
        {
          type: 'input',
          label: '游戏标签',
          key: 'game_tag',
          span: 4,
        },
        {
          type: 'select',
          label: '渠道',
          key: 'channel',
          placeholder: '请选择渠道',
          span: 4,
          options: this.options.channel,
        },
        {
          type: 'select',
          label: '昵称',
          key: 'nickname',
          placeholder: '请选择昵称',
          span: 4,
          options: this.options.nickname,
        },
        {
          span: 5,
          type: 'date-picker',
          label: '会话时间',
          key: 'date',
          dateType: false,
          empty: false,
          pick: true,
          showDayWeek:true
        },
        {
          type: 'select',
          label: '质检人',
          key: 'admin_id',
          placeholder: '请选择质检人',
          span: 4,
          options: this.options.admin,
        },
        {
          type: 'select',
          label: '质检结果',
          key: 'check_result',
          placeholder: '请选择质检结果',
          span: 4,
          options: this.options.result,
        },
        {
          type: 'select',
          label: '是否超时',
          key: 'is_outdated',
          placeholder: '是否超时',
          span: 4,
          options: this.options.time,
        },
        {
          type: 'select',
          label: '是否有标签',
          key: 'is_tag',
          placeholder: '是否有标签',
          span: 4,
          options: this.options.tag,
        },
        {
          type: 'input',
          label: '备注',
          key: 'remark',
          span: 4,
        },
        {
          type: 'input',
          label: '聊天内容',
          key: 'content',
          span: 4,
        },
        {
          type: 'select',
          label: '是否出库',
          key: 'is_vip_checkout',
          placeholder: '是否出库',
          span: 4,
          options: this.options.checkout,
        },
      ];
    },
  },
  created() {
    this.getList(this.listQuery);
  },
  methods: {
    // 获取列表数据
    async getList(query) {
      // console.log(this.options)
      this.listLoading = true;
      const { data } = await getInspectionList(Object.assign(this.listQuery, query));
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.tableData = data.data.data;
      this.total = data.data.total;
      this.listLoading = false;
      // 超时配置相关按钮的显示控制字段
      this.batchShow = data.data.batch_check_button;
      // 转移按钮的显示
      this.transferBtn = data.data.transfer_button;
    },
    search(data) {
      if (!data.start_date) {
        Object.assign(data, {
          start_date: dayjs(new Date() - 1000 * 60 * 60 * 24 * 7).format('YYYY-MM-DD')
        })
      }
      if (!data.end_date) {
        Object.assign(data, {
          end_date: dayjs(new Date()).format('YYYY-MM-DD')
        })
      }
      Object.assign(this.listQuery, data, { start_time: data.start_date, end_time: data.end_date });
      delete this.listQuery.start_date;
      delete this.listQuery.end_date;
      delete this.listQuery.date;
      this.getList(this.listQuery);
    },
    reset() {
      this.listQuery = {
        is_checked: 1,
        page: 1,
        limit: 10,
      };
    },
    refresh() {
      this.getList(this.listQuery);
    },
    chooseAcc(row) {
      this.$refs.drawer.chooseAcc(row);
    },
    async time() {
      const { data } = await getConfigSetting({ config_key: 'inspection.outdated_time' });
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.setTime = data.data[0] ? data.data[0] : '';
      this.dialogVisible = true;
      this.$refs.dialog.resetForm();
      this.$refs.dialog.editForm({ config_values: this.setTime });
    },
    // 关闭弹窗
    closeDialog() {
      this.dialogVisible = false;
      this.overTimedialogVisible = false;
      this.$refs.dialog.resetForm();
    },
    // 弹窗确认
    async dialogSure(form) {
      const { data } = await setConfigSetting(Object.assign({ config_key: 'inspection.outdated_time', config_values: [form['config_values']] }));
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.$message.success('操作成功');
      this.closeDialog();
      this.refresh();
    },
    // 新增的超时配置相关按钮的点击事件
    // 点击超时配置
    overTimeSet() {
      // 点击超时配置跳转到超时配置页面
      this.$router.push({ path: '/overTimeSet' });
    },
    // 点击更新超时状态
    updateOverTime() {
      // 点击更新超时状态 给一个二次确认的弹窗
      this.updateOverTimeShow = true;
    },
    updateCancel() {
      this.updateOverTimeShow = false;
    },
    async updateSure() {
      const { data } = await operateOverTimeSet();
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.$message.success(data.message);
      this.updateCancel();
    },
    // 点击修复超时状态按钮
    operateOverTime() {
      this.overTimedialogVisible = true;
    },
    async overTimedialogSure(form) {
      const { data } = await operateOverTimeSet({ calc_date: form['calc_date'] });
      if (data.code !== 200) {
        this.$message.error(data.message);
        return;
      }
      this.$message.success(data.message);
      this.closeDialog();
      this.refresh();
    },
    // 点击去除超时状态
    async clearOverTime() {
      if (this.transferIdArray.length <= 0) {
        return this.$message.warning('请先选择数据');
      } else {
        const { data } = await eraseInspectionTimeout({ id_array: this.transferIdArray });
        if (data.code !== 200) {
          this.$message.error(data.message);
          return;
        }
        this.$message.success('去除成功');
        // 重新获取表格数据
        this.getList(this.listQuery);
      }
    },
    // 新增的转移相关
    async operateTransfer() {
      // transferDataList
      if (this.transferIdArray.length <= 0) {
        return this.$message.warning('请先选择数据再转移');
      } else {
        const { data } = await transferDataList({ id_array: this.transferIdArray });
        if (data.code !== 200) {
          this.$message.error(data.message);
          return;
        }
        this.$message.success('转移成功');
        // 重新获取表格数据
        this.getList(this.listQuery);
      }
    },
    handleSelectionChange(val) {
      if (val.length > 0) {
        this.transferIdArray = [];
        val.forEach((item) => {
          this.transferIdArray.push(item.id);
        });
      }
    },
  },
};
</script>